import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';
import Steps, { Step } from 'rc-steps';
import { putRequest } from '../../../requestUtils';
import { analyticsTrack } from '../../../analyticsUtils';
import alertTriangle from '../../../../assets/images/alert-triangle.svg';
import AddCoworkersModal from '../../AddCoworkersModal';
import './NextSteps.scss';
import RegistrationModal from '../../RegistrationModal';
var proposalTabLinks = ['Click "Hire" on the best proposal to begin working with your consultant', 'Review proposals & choose who to interview'];
var titleMapping = {
  'Onboarding Guide': 'onboarding_guide',
  'Timesheet Tips': 'timesheet_tips',
  'Extend the contract / Hire again': 'extend_contract_or_hire_again',
  'Offboarding Guide': 'offboarding_guide',
  'Schedule a call to expedite matching': 'scoping_call'
};
var recommendationTabLinks = ['Browse & connect with talent'];
var collaboratorsModal = ['Invite collaborators'];
var screeningQuestion = ['Add screening questions for applicants to answer'];

// Read invitee email from URL query params to prefill registration email
var invitedEmailFromUrl = typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('email') : null;
var cssClass = function cssClass(projectStatus, item, nextStep) {
  if (projectStatus === 'clora_matched') {
    return 'rc-steps-agreement-status';
  }
  if (nextStep && item.step === nextStep.step) {
    return 'rc-steps-item-process';
  }
  return '';
};
var setStepStatus = function setStepStatus(currentStep, item) {
  if (currentStep === item.step) {
    return 'process';
  }
  return item.completed ? 'finish' : 'wait';
};
var NextSteps = /*#__PURE__*/function (_Component) {
  function NextSteps(props) {
    var _this;
    _classCallCheck(this, NextSteps);
    _this = _callSuper(this, NextSteps, [props]);
    var nextStepsData = props.nextStepsData;
    var nextStep = nextStepsData.next_steps.find(function (item) {
      return item.completed === false;
    });
    _this.state = {
      prevNextStepsData: nextStepsData,
      currentStep: null,
      nextSteps: nextStepsData.next_steps || [],
      nextStep: nextStep || null,
      projectStatus: nextStepsData.project_status,
      resourceId: nextStepsData.resource_id,
      showAddCoworkerModal: false,
      showRegistrationModal: false
    };
    _this.handleOnChange = _this.handleOnChange.bind(_this);
    _this.renderNextSteps = _this.renderNextSteps.bind(_this);
    _this.toggleRegistrationModal = _this.toggleRegistrationModal.bind(_this);
    return _this;
  }
  _inherits(NextSteps, _Component);
  return _createClass(NextSteps, [{
    key: "handleOnChange",
    value: function handleOnChange(currentStep) {
      var nextSteps = this.state.nextSteps;
      var _this$props = this.props,
        clickTab = _this$props.clickTab,
        salesBookingLink = _this$props.salesBookingLink,
        userSignedIn = _this$props.userSignedIn,
        location = _this$props.location;
      if (userSignedIn) {
        var clickedItem = nextSteps.find(function (item) {
          return item.step === currentStep;
        });
        if (recommendationTabLinks.includes(clickedItem.title)) {
          clickTab('recommended');
        } else if (proposalTabLinks.includes(clickedItem.title)) {
          clickTab('proposals');
        } else if (['Submit your project', 'Tell us how the interview went'].includes(clickedItem.title)) {
          window.location.href = clickedItem.link_url;
        } else if (Object.keys(titleMapping).includes(clickedItem.title)) {
          window.open(clickedItem.title === 'Schedule a call to expedite matching' ? salesBookingLink : clickedItem.link_url, '_blank');
          this.handleUpdate(clickedItem);
        } else if (collaboratorsModal.includes(clickedItem.title)) {
          this.setState({
            showAddCoworkerModal: true
          });
        } else if (screeningQuestion.includes(clickedItem.title)) {
          clickTab('screening');
        }
        this.setState({
          currentStep: currentStep,
          nextStep: null
        });
      } else {
        this.toggleRegistrationModal();
        analyticsTrack('Clicked on next steps CTA', {
          location: location
        });
        analyticsTrack('Opened registration modal', {
          location: location
        });
      }
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(clickedItem) {
      var _this2 = this;
      var resourceId = this.state.resourceId;
      var csrfToken = this.props.csrfToken;
      putRequest("/projects/".concat(resourceId, "/update_next_steps"), {
        action_clicked: titleMapping[clickedItem.title]
      }, csrfToken).then(function (_ref) {
        var data = _ref.data;
        _this2.setState({
          nextSteps: data.next_steps,
          currentStep: null,
          nextStep: data.next_steps.find(function (item) {
            return item.completed === false;
          })
        });
      });
    }
  }, {
    key: "toggleRegistrationModal",
    value: function toggleRegistrationModal() {
      this.setState(function (prev) {
        return {
          showRegistrationModal: !prev.showRegistrationModal
        };
      });
    }
  }, {
    key: "renderNextSteps",
    value: function renderNextSteps() {
      var _this3 = this;
      var _this$state = this.state,
        nextSteps = _this$state.nextSteps,
        currentStep = _this$state.currentStep,
        projectStatus = _this$state.projectStatus,
        nextStep = _this$state.nextStep,
        userSignedIn = _this$state.userSignedIn;
      return /*#__PURE__*/React.createElement(Fragment, null, nextSteps.map(function (item) {
        return /*#__PURE__*/React.createElement(Step, {
          key: item.step,
          stepIndex: item.step,
          title: item.title,
          status: setStepStatus(currentStep, item),
          className: cssClass(projectStatus, item, nextStep),
          disabled: userSignedIn && item.completed,
          onStepClick: _this3.handleOnChange
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$state2 = this.state,
        currentStep = _this$state2.currentStep,
        showAddCoworkerModal = _this$state2.showAddCoworkerModal,
        showRegistrationModal = _this$state2.showRegistrationModal;
      var _this$props2 = this.props,
        csrfToken = _this$props2.csrfToken,
        initialTeamMembers = _this$props2.initialTeamMembers,
        editableRoles = _this$props2.editableRoles,
        basePermissionsUrl = _this$props2.basePermissionsUrl,
        invitableRoles = _this$props2.invitableRoles,
        googleOmniauthUrl = _this$props2.googleOmniauthUrl,
        msOmniauthUrl = _this$props2.msOmniauthUrl,
        signInUrl = _this$props2.signInUrl,
        location = _this$props2.location,
        inviterId = _this$props2.inviterId,
        projectResourceId = _this$props2.projectResourceId;
      return /*#__PURE__*/React.createElement("div", {
        className: "items-list-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "header-container"
      }, /*#__PURE__*/React.createElement("h3", null, "Next Steps"), /*#__PURE__*/React.createElement(SVG, {
        src: alertTriangle,
        title: "Project next steps"
      })), /*#__PURE__*/React.createElement("div", {
        className: "items-container"
      }, /*#__PURE__*/React.createElement(Steps, {
        direction: "vertical",
        current: currentStep
      }, this.renderNextSteps())), /*#__PURE__*/React.createElement(AddCoworkersModal, {
        csrfToken: csrfToken,
        initialTeamMembers: initialTeamMembers,
        invitableRoles: invitableRoles,
        editableRoles: editableRoles,
        basePermissionsUrl: basePermissionsUrl,
        location: "next-steps-component",
        showModalCallback: function showModalCallback() {
          _this4.setState({
            showAddCoworkerModal: false
          });
        },
        modalIsOpen: showAddCoworkerModal
      }), /*#__PURE__*/React.createElement(RegistrationModal, {
        csrfToken: csrfToken,
        showModal: showRegistrationModal,
        hideModal: this.toggleRegistrationModal,
        googleOmniauthUrl: googleOmniauthUrl,
        msOmniauthUrl: msOmniauthUrl,
        signInUrl: signInUrl,
        showTestimonials: false,
        location: location,
        inviterId: inviterId,
        projectResourceId: projectResourceId,
        invitedEmail: invitedEmailFromUrl
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      // Check if nextStepsData prop has changed
      if (nextProps.nextStepsData !== prevState.prevNextStepsData) {
        // Return new state object to update nextSteps
        // and Store the current nextStepsData prop for comparison
        return {
          nextSteps: nextProps.nextStepsData.next_steps,
          prevNextStepsData: nextProps.nextStepsData
        };
      }
      return null; // No state update necessary
    }
  }]);
}(Component);
NextSteps.propTypes = {
  clickTab: PropTypes.func,
  nextStepsData: PropTypes.shape({}),
  csrfToken: PropTypes.string.isRequired,
  initialTeamMembers: PropTypes.shape({}),
  invitableRoles: PropTypes.arrayOf(PropTypes.string),
  editableRoles: PropTypes.arrayOf(PropTypes.string),
  basePermissionsUrl: PropTypes.string.isRequired,
  salesBookingLink: PropTypes.string,
  googleOmniauthUrl: PropTypes.string.isRequired,
  msOmniauthUrl: PropTypes.string.isRequired,
  signInUrl: PropTypes.string.isRequired,
  userSignedIn: PropTypes.bool,
  location: PropTypes.string,
  inviterId: PropTypes.string,
  projectResourceId: PropTypes.string
};
NextSteps.defaultProps = {
  nextStepsData: {},
  clickTab: function clickTab() {},
  initialTeamMembers: {
    current_user_permission: null,
    team_members: []
  },
  invitableRoles: [],
  editableRoles: [],
  salesBookingLink: null,
  userSignedIn: true,
  location: 'Projects view',
  inviterId: null,
  projectResourceId: null
};
export default NextSteps;